export default "__VITE_ASSET__DDGPstbF__"